export default __webpack_public_path__ + "assets/a99e2c9187566bdb8c6bd200fb576db8/01.jpg";